/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Order_FiverrInputs */

const en_contact_order_fiverr = /** @type {(inputs: Contact_Order_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order on Fiverr`)
};

const ar_contact_order_fiverr = /** @type {(inputs: Contact_Order_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اطلب عبر Fiverr`)
};

const bn_contact_order_fiverr = /** @type {(inputs: Contact_Order_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiverr-এ অর্ডার করুন`)
};

const de_contact_order_fiverr = /** @type {(inputs: Contact_Order_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellung auf Fiverr`)
};

const es_contact_order_fiverr = /** @type {(inputs: Contact_Order_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orden en Fiverr`)
};

const fr_contact_order_fiverr = /** @type {(inputs: Contact_Order_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commandez sur Fiverr`)
};

const pt_contact_order_fiverr = /** @type {(inputs: Contact_Order_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedido no Fiverr`)
};

const zh_contact_order_fiverr = /** @type {(inputs: Contact_Order_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiverr 订单`)
};

const tr_contact_order_fiverr = /** @type {(inputs: Contact_Order_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiverr'da Sipariş Ver`)
};

const ru_contact_order_fiverr = /** @type {(inputs: Contact_Order_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заказ на Fiverr`)
};

const pl_contact_order_fiverr = /** @type {(inputs: Contact_Order_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamówienie na Fiverr`)
};

/**
* | output |
* | --- |
* | "Order on Fiverr" |
*
* @param {Contact_Order_FiverrInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_order_fiverr = /** @type {((inputs?: Contact_Order_FiverrInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Order_FiverrInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_contact_order_fiverr(inputs)
	if (locale === "bn") return bn_contact_order_fiverr(inputs)
	if (locale === "de") return de_contact_order_fiverr(inputs)
	if (locale === "es") return es_contact_order_fiverr(inputs)
	if (locale === "fr") return fr_contact_order_fiverr(inputs)
	if (locale === "pt") return pt_contact_order_fiverr(inputs)
	if (locale === "zh") return zh_contact_order_fiverr(inputs)
	if (locale === "tr") return tr_contact_order_fiverr(inputs)
	if (locale === "ru") return ru_contact_order_fiverr(inputs)
	if (locale === "pl") return pl_contact_order_fiverr(inputs)
	return en_contact_order_fiverr(inputs)
});